import React, { useState, useEffect } from "react";
import { Theme, useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Select,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  TextField,
  Checkbox,
  Typography,
  FormControlLabel,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { getCustomerNums, getCustomersList } from "../../utils/GetPlanning";
import { useLocalStorage } from "../../componentUtils/LocalStorage";
interface Inputs {
  onCusSelectionChange: any;
  onSettlementDateSelChange: any;
  resetSettlementState: any;
  showLoading: any;
  settlementsData: any;
  selectedSettlement: any;
}
interface CInvHeaderState {
  inventoryTrackingIdValue: string;
  customerNumbers: string[];
  selectedCustomer: string;
}

export default function AdjustClosingInvHeader(props: Inputs) {
  const theme: Theme = useTheme();
  const useStyles = makeStyles((theme: Theme) => ({
    cont: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    grid: {
      marginLeft: theme.spacing(1),
    },
    load: {
      textAlign: "center",
      justify: "center",
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    formControl: {
      width: 500,
    },
  }));

  enum SearchType {
    ShipmentNumber = "ShipmentNumber",
    AssetNumber = "AssetNumber",
    CustomerNumber = "CustomerNumber",
  }

  const classes = useStyles();
  const [defaultSalesOffice, setDefaultSalesOffice] = useLocalStorage(
    "SETTINGS.defaultSalesOffice",
    ""
  );
  const [searchType, setSearchType] = useState<SearchType>(
    SearchType.ShipmentNumber
  );
  const [state, setState] = useState<CInvHeaderState>({
    inventoryTrackingIdValue: "",
    customerNumbers: [],
    selectedCustomer: "",
  });
  const [isLoaded, setIsLoaded] = useState(false);
  const [dataState, setDataState] = useState({
    allCustomerList: [],
  });

  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");

  //   useEffect(() => {
  //     if (isLoaded) return;
  //     setIsLoaded(true);
  //     props.showLoading(true);
  //     getCustomersList(salesOrg.toString()).then(
  //       (v: any) => {
  //         setDataState({
  //           allCustomerList: v
  //         });
  //         props.showLoading(false);
  //       });

  //  }, [state]);

  const handleCusNoChange = (event: any) => {
    let value = event.target.value;
    setState({ ...state, selectedCustomer: value });
    props.onCusSelectionChange(salesOrg, value, true);
  };
  const handleVisitDateChange = (event: any) => {
    let value = event.target.value;
    const selSettlement = props.settlementsData.find(
      (settlement: any) => settlement.visitDt === value
    );
    props.onSettlementDateSelChange(selSettlement);
  };
  const handleCustomersSearchClick = () => {
    if (salesOrg && state.inventoryTrackingIdValue) {
      props.showLoading(true);
      if (
        searchType === SearchType.ShipmentNumber ||
        searchType === SearchType.AssetNumber
      ) {
        getCustomerNums(
          salesOrg,
          state.inventoryTrackingIdValue,
          searchType.valueOf()
        ).then((d: any) => {
          const cusNums = Array.from(
            new Set(d.map((a: any) => a.customerNum))
          ).map((customerNum) => {
            return d.find((b: any) => b.customerNum === customerNum);
          });
          props.showLoading(false);
          setState({
            ...state,
            customerNumbers: cusNums,
            selectedCustomer:
              cusNums && cusNums.length > 0 ? cusNums[0].customerNum : "",
          });
          props.onCusSelectionChange(
            salesOrg,
            cusNums && cusNums.length > 0 ? cusNums[0].customerNum : "",
            true
          );
        });
      } else {
        // Added for Search Customer via Button Click
        props.onCusSelectionChange(
          salesOrg,
          state.inventoryTrackingIdValue,
          true
        );
      }
    }
  };
  const handleCustomerInputChange = (e: any) => {
    e.persist();
    if (
      searchType === SearchType.ShipmentNumber ||
      searchType === SearchType.AssetNumber
    ) {
      setState({ ...state, inventoryTrackingIdValue: e.target.value.trim() });
      props.resetSettlementState();
    } else {
      if (
        searchType === SearchType.CustomerNumber &&
        e.target.value.length !== 0
      ) {
        setState({ ...state, inventoryTrackingIdValue: e.target.value.trim() });
        props.resetSettlementState(); //TO-DO Added for Disable AutoSearch
        //TO-DO Commented for Disable AutoSearch //props.onCusSelectionChange(salesOrg, e.target.value, true);
      }
    }
  };
  const getStyles = (key: string, arr: string[]) => {
    return {
      fontWeight:
        arr.indexOf(key) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  };

  const resetCurrentState = () => {
    setState({
      inventoryTrackingIdValue: "",
      customerNumbers: [],
      selectedCustomer: "",
    });
    props.resetSettlementState();
  };

  const handleSearchType = (value: SearchType) => {
    setSearchType(value as SearchType);
    resetCurrentState();
  };
  //console.log("cusNum", searchType);

  return (
    <Paper className={classes.cont}>
      <Grid className={classes.grid} container spacing={1}>
        <Grid item xs={5}>
          <FormControl>
            {/* <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel> */}
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              value={searchType}
              name="radio-buttons-group"
            >
              <FormControlLabel
                value={SearchType.ShipmentNumber}
                control={<Radio />}
                label="Shipment Number"
                onChange={() => handleSearchType(SearchType.ShipmentNumber)}
              />
              <FormControlLabel
                value={"AssetNumber"}
                control={<Radio />}
                label="Asset Number"
                onChange={() => handleSearchType(SearchType.AssetNumber)}
              />
              <FormControlLabel
                value={SearchType.CustomerNumber}
                control={<Radio />}
                label="Customer Number"
                onChange={() => handleSearchType(SearchType.CustomerNumber)}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl className={classes.formControl}>
            <TextField
              // type="number"
              value={state.inventoryTrackingIdValue}
              label={
                searchType === SearchType.ShipmentNumber.valueOf()
                  ? "Shipment Number"
                  : searchType === SearchType.AssetNumber.valueOf()
                  ? "Asset Number"
                  : "Customer Number"
              }
              inputProps={{ min: 0 }}
              onChange={(e) => handleCustomerInputChange(e)}
            ></TextField>
          </FormControl>
        </Grid>
        {(searchType === SearchType.ShipmentNumber &&
          state.inventoryTrackingIdValue) ||
        (searchType === SearchType.AssetNumber &&
          state.inventoryTrackingIdValue) ? (
          <>
            <Grid item>
              <Button
                variant="outlined"
                onClick={(e: any) => handleCustomersSearchClick()}
              >
                Search Customer Data
              </Button>
            </Grid>
            <Grid item xs={4}>
              <InputLabel id="select-multiple-so-label">
                Customer Number
              </InputLabel>
              <Select
                fullWidth
                value={state.selectedCustomer || ""}
                onChange={handleCusNoChange}
                input={<Input id="select-multiple-so" />}
              >
                {state.customerNumbers.map((cus: any) => (
                  <MenuItem key={cus.customerNum} value={cus.customerNum}>
                    {cus.customerNum} : {cus.name.name1} : {cus.location}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={4}>
              <InputLabel id="select-multiple-so-label">
                {searchType === SearchType.ShipmentNumber?'Visit Date':searchType === SearchType.AssetNumber?'Visit Date / Shipment Number':''}
              </InputLabel>
              {searchType === SearchType.ShipmentNumber &&
              state.inventoryTrackingIdValue ? (
                <Typography>
                  {props.selectedSettlement.visitDt.split('T')[0]}
                </Typography>
              ) : searchType === SearchType.AssetNumber &&
                state.inventoryTrackingIdValue ? (
                <Select
                  fullWidth
                  value={props.selectedSettlement.visitDt || ""}
                  onChange={handleVisitDateChange}
                  input={<Input id="select-multiple-so" />}
                >
                  {props.settlementsData &&
                    props.settlementsData.map(
                      (settlementData: any, index: number) => (
                        <MenuItem
                          key={settlementData.visitDt}
                          value={settlementData.visitDt}
                        >
                          {settlementData.visitDt.split('T')[0] +
                            " : " +
                            settlementData.shipmentNum}
                        </MenuItem>
                      )
                    )}
                </Select>
              ) : (
                <></>
              )}
            </Grid>
          </>
        ) : searchType === SearchType.CustomerNumber &&
          state.inventoryTrackingIdValue ? (
          <>
            <Grid item>
              <Button
                variant="outlined"
                onClick={(e: any) => handleCustomersSearchClick()}
              >
                Search Customer Data
              </Button>
            </Grid>
            <Grid item xs={4}>
              <InputLabel id="select-multiple-so-label">Visit Date / Shipment Number</InputLabel>
              <Select
                fullWidth
                value={props.selectedSettlement.visitDt || ""}
                onChange={handleVisitDateChange}
                input={<Input id="select-multiple-so" />}
              >
                {props.settlementsData &&
                  props.settlementsData.map(
                    (settlementData: any, index: number) => (
                      <MenuItem
                        key={settlementData.visitDt}
                        value={settlementData.visitDt}
                      >
                        {settlementData.visitDt.split('T')[0] +
                          " : " +
                          settlementData.shipmentNum}
                      </MenuItem>
                    )
                  )}
              </Select>
            </Grid>
            <Grid item xs={4}>
              <InputLabel id="select-multiple-so-label">Customer Name</InputLabel>
              <Typography>
                  {props.selectedSettlement.customerName}
                </Typography>
            </Grid>
          </>
        ) : null}
      </Grid>
    </Paper>
  );
}
